export default __webpack_public_path__ + "static/media/bootstrap.aaba30bc.png";